<template>
    <div ref="app" class="contact-buttons">
        <Call v-if="items.call && items.call.length" :phones="items.call" :is-d-s="isDS"></Call>
        <Sms v-if="items.sms && items.sms.length" :phones="items.sms" :is-d-s="isDS"></Sms>
        <WhatsApp v-if="items.whatsApp && items.whatsApp.length" :phones="items.whatsApp" :is-d-s="isDS"></WhatsApp>
    </div>
</template>

<script>
import Call from './components/Call';
import Sms from './components/Sms';
import WhatsApp from './components/WhatsApp';
import { ContactPanel } from './util/ContactPanel';

export default {
    name: 'PhoneButtons',
    components: { Call, Sms, WhatsApp },
    props: {
        sets: { type: String, required: true },
        phones: { type: String, required: true },
        whatsappHint: { type: String, required: true },
        isDS: { type: Boolean, required: false }
    },
    computed: {
        items () {
            return JSON.parse(this.phones);
        },
        settings () {
            return JSON.parse(this.sets);
        }
    },
    mounted: function () {
        this.bindContactPanel(this.settings);
    },
    watch: {
        sets: function (value) {
            this.currentPanel.clean();
            this.bindContactPanel(JSON.parse(value));
        }
    },
    methods: {
        bindContactPanel (value) {
            this.currentPanel = new ContactPanel({ // eslint-disable-line no-new
                wrapper: this.$refs.app,
                advertLink: value.advertLink,
                messageText: value.messageText,
                whatsappHint: this.whatsappHint,
                vehicleId: value.vehicleId,
                statUserId: value.statUserId,
                domainName: value.domainName,
                callStatId: value.callStatId,
                smsStatId: value.smsStatId,
                whatsAppStatId: value.whatsAppStatId,
                googleConversion: value.googleConversion,
                googlePhoneTrack: value.googlePhoneTrack,
                facebookUID: value.facebookUID,
                isOpened: value.isOpened
            }); // todo: split to components: the app has to depend on data - not from HTML elements
        }
    }
};
</script>

<style>
.contact-buttons .mobile-buttons button {
    text-align: left;
    position: relative;
    width: 100%;
}
.contact-buttons .mobile-buttons {
    margin-bottom: 20px;
}
.indicator {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}
.contact-icon {
    display: inline-block;
    font-size: inherit;
    margin-right: 5px;
    width: 16px;
    height: 16px;
    text-align: center;
}
.contact-buttons .mobile-buttons button {
    text-align: left;
    position: relative;
}
.contact-panel-wrapper {
    position: fixed;
    bottom: -100%;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    background-color: rgba(0,0,0,0.0);
    pointer-events: none;
    transition: background-color 500ms ease-in-out;
}
.contact-panel-wrapper.active {
    bottom: 0;
    pointer-events: all;
    background-color: rgba(0,0,0,0.7);
}
.contact-panel-drawer {
    position: absolute;
    bottom: -100%;
    left: 0;
    width: 100%;
    z-index: 99999;
    padding: 20px;
    transition-property: bottom;
    transition-duration: 250ms;
    transition-timing-function: ease-in-out;
}
.contact-panel-wrapper.active .contact-panel-drawer {
    bottom: 0;
    transition-delay: 0.2s;
}
.action-button {
    width: 100%;
    text-align: left;
    padding: 10px 16px!important;
}
.contact-panel-drawer .action-button {
    background: white;
    color: #005094;
    margin-top: 10px;
}
.contact-panel-drawer .cancel-button {
    text-align: center;
    font-weight: bold;
}
</style>
